import { Directive, computed, inject, input, untracked } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { scrollToElementById } from 'app/core/utils/scroll-to-element.util';
import { filter, map } from 'rxjs';

function useCurrentUrl() {
  const router = inject(Router);
  const url = toSignal(
    router.events.pipe(
      filter((e): e is NavigationEnd => e instanceof NavigationEnd),
      map((e) => router.routerState.snapshot.url)
    ),
    { initialValue: router.routerState.snapshot.url }
  );
  return url;
}

@Directive({
  selector: 'a[href][shebaSkipTo]',
  standalone: true,
  host: {
    '(click)': 'clickHandler($event)',
    '[href]': 'newHref()'
  }
})
export class ShebaSkipToDirective {
  href = input<string>('');
  url = useCurrentUrl();
  elementId = computed(() => this.href()?.replace('#', '') ?? '');
  newHref = computed(() => this.url() + '#' + this.elementId());

  clickHandler(event: MouseEvent) {
    event.preventDefault();
    const elementId = untracked(this.elementId);
    scrollToElementById(elementId);
  }
}
